import React from "react";
import { slide as Menu } from "react-burger-menu";
import { Link } from "react-router-dom";

class SideMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: props.menuOpen,
      layout: props.layout,
      selectedMainMenu: props.selectedMainMenu,
      selectedSubMenu: props.selectedSubMenu,
    };
  }

  showSettings(event) {
    event.preventDefault();
  }

  handleStateChange(state) {
    this.setState({ menuOpen: state.isOpen });
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  render() {
    var styles_xl = {
      bmBurgerButton: {
        position: "fixed",
        width: "24px",
        height: "23px",
        left: "24px",
        top: "43px",
        display: "none",
      },
      bmBurgerBars: {
        background: "#373a47",
      },
      bmBurgerBarsHover: {
        background: "#a90000",
      },
      bmCrossButton: {
        height: "24px",
        width: "24px",
      },
      bmCross: {
        background: "#bdc3c7",
        display: "none",
      },
      bmMenuWrap: {
        position: "fixed",
        fontFamily: "Space Grotesk",
        width: "260px",
        height: "100%",
        zIndex: "51",
        top: "0",
        fontSize: "smaller",
        borderRightWidth: "1px",
      },
      bmMenu: {
        background: "#fff",
      },
      bmMorphShape: {
        fill: "#373a47",
      },
      bmItemList: {
        color: "#000",
        paddingTop: "2rem",
        display: "flex",
        flexDirection: "column",
      },
      bmItem: {
        display: "inline-block",
        marginBottom: "0.5rem",
        marginTop: "0.5rem",
        padding: "0.2rem 0.4rem 0.2rem 1.5rem",
      },
      bmOverlay: {
        background: "rgba(0, 0, 0, 0.3)",
        top: "0",
        display: "none",
      },
    };
    var styles_mobile = {
      bmBurgerButton: {
        position: "fixed",
        width: "24px",
        height: "23px",
        left: "24px",
        top: "43px",
      },
      bmBurgerBars: {
        background: "#373a47",
      },
      bmBurgerBarsHover: {
        background: "#a90000",
      },
      bmCrossButton: {
        height: "24px",
        width: "24px",
      },
      bmCross: {
        background: "#bdc3c7",
      },
      bmMenuWrap: {
        fontFamily: "Space Grotesk",
        position: "fixed",
        height: "100%",
        fontSize: "smaller",
        top: "0",
      },
      bmMenu: {
        background: "rgb(16 15 19)",
      },
      bmMorphShape: {
        fill: "#373a47",
      },
      bmItemList: {
        color: "#fff",
        padding: "0.8em",
        paddingTop: "2rem",
        display: "flex",
        flexDirection: "column",
      },
      bmItem: {
        display: "inline-block",
        marginBottom: "0.5rem",
        marginTop: "0.5rem",
        padding: "0.2rem 0.4rem 0.2rem 1.5rem",
      },
      bmOverlay: {
        background: "rgba(0, 0, 0, 0.3)",
        top: "0",
      },
    };
    // NOTE: You also need to provide styles, see https://github.com/negomi/react-burger-menu#styling
    return (
      <Menu
        disableCloseOnEsc
        styles={this.state.layout === "mobile" ? styles_mobile : styles_xl}
        isOpen={this.state.menuOpen}
        onStateChange={state => this.handleStateChange(state)}
      >
        <Link id="home" className="focus:outline-none" to="/">
          <svg
            className="w-40 focus:outline-none pb-0 flex sm:w-40 fill-current text-white xl:text-gray-900"
            xmlns="http://www.w3.org/2000/svg"
            width="520.982"
            height="50"
            viewBox="0 0 520.982 163.931"
          >
            <path
              d="M474.937,45.062v71.984h-12v-72Zm-385,41.025h-25a2.652,2.652,0,0,1-3-3v-2a2.652,2.652,0,0,1,3-3h26l.039-12h-20.3a4.281,4.281,0,0,0-2.736.988L51.484,80.444a4.285,4.285,0,0,0-1.547,3.3v8.331a3.829,3.829,0,0,0,4,4.016h26a2.652,2.652,0,0,1,3,3v3c0,2-1.019,2.953-3,3l-30,.046v11.954H73.9a4.287,4.287,0,0,0,2.653-.921l16.388-13.079a4.825,4.825,0,0,0,2-4v-8A4.724,4.724,0,0,0,89.937,86.087Zm64.945,5.872c0,16.152-11.8,27.128-26.921,27.128s-26.92-10.976-26.92-27.128,11.8-27.127,26.92-27.127S154.882,75.808,154.882,91.959Zm-13.046,0c0-9.318-5.616-15.872-13.9-15.872s-13.85,6.554-13.85,15.872,5.567,16.128,13.85,16.128S141.836,101.278,141.836,91.959ZM282.86,107.484c-8.391,0-13.879-6.214-13.879-15.529s6-15.53,13.879-15.53c6.453,0,10.33,3.49,12.03,8.172L306.2,78.016c-4.1-8.063-12.1-13.183-23.553-13.183-14.913,0-26.714,11.174-26.714,27.122s11.8,27.132,26.714,27.132c11.2,0,19.149-4.832,23.285-12.5l-11.374-6.561C292.693,104.6,289.114,107.484,282.86,107.484Zm79.323-16.393v4h-38c.518,6.834,5.494,12.814,12.949,12.814,7.248,0,11.079-4.038,12.839-7.662l10.665,6.212c-3.521,5.384-9.526,12.632-23.3,12.632-15.324,0-26.4-11.6-26.4-27.542,0-15.531,10.664-26.713,25.781-26.713C351.628,64.832,362.183,75.663,362.183,91.091Zm-13.765-4.412c-.932-6.523-5.073-10.665-11.8-10.665-7.352,0-11.183,4.349-12.219,10.665Zm36.75-42.6-13.683,11.36a4.283,4.283,0,0,0-1.548,3.3v58.315h13v-37a3.815,3.815,0,0,1,4-4h9v-10h-9a3.816,3.816,0,0,1-4-4v-3a3.826,3.826,0,0,1,4-4h12V43.087H387.9A4.285,4.285,0,0,0,385.168,44.074ZM197.937,92.593c0,9.111-4.231,14.494-12,14.494h-7a3.816,3.816,0,0,1-4-4v-37h-13v36.156a4.286,4.286,0,0,0,1.548,3.3l13.759,11.56a4.281,4.281,0,0,0,2.735.987h1.958c9.422,0,13.929-4.238,16-9h1v8h12l.047-51H197.937Zm37.7-25.519L221.485,78.817a4.283,4.283,0,0,0-1.548,3.3v34.973h13v-35a3.815,3.815,0,0,1,4-4h15v-12H238.375A4.283,4.283,0,0,0,235.64,67.074Zm204.3,25.478c0,9.111-4.231,14.494-12,14.494h-7a3.815,3.815,0,0,1-4-4v-37h-13V102.2a4.286,4.286,0,0,0,1.548,3.3l13.759,11.56a4.281,4.281,0,0,0,2.735.987h1.958c9.422,0,13.929-4.238,16-9h1v8h12l.047-51H439.937Z"
              fill="currentColor"
            />
          </svg>

          <h2 className="ml-4 pb-4 font-bold text-blue-800">graphOS v0.1</h2>
          {window.REACT_APP_ENV !== "PROD" && (
            <h2 className="ml-4 pb-4 font-bold text-red-800">DEVELOPMENT MODE</h2>
          )}
        </Link>

        <Link
          id="Clients"
          className={`menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none `}
          to="/clients"
        >
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 24 24"
            className="text-white xl:text-gray-900 inline mr-2 mb-1"
          >
            <title>Decoration / Icon / Navigation / People</title>
            <g
              id="Decoration-/-Icon-/-Navigation-/-People"
              stroke="none"
              strokeWidth="1"
              fill="currentColor"
              fillRule="evenodd"
            >
              <path
                d="M4.04052021,15.0694627 C6.70680362,12.3926711 11.0003789,12.3235163 13.7506637,14.8682215 L13.9400002,15.0500001 C14.748117,14.4228329 15.7274235,14.0598841 16.7449101,14.0067914 L17.0000002,14 C19.6887495,14.0000003 21.881818,16.1223106 21.9953807,18.783111 L22.0000002,19.0000004 L21.9932725,19.1166215 C21.9355072,19.6139604 21.5128346,20.0000003 21.0000002,20.0000004 C20.4871625,20.0000004 20.0644928,19.6139604 20.0067279,19.1166215 L19.9913633,18.7763117 C19.9462051,18.1825447 19.7251087,17.613746 19.3538224,17.1438802 C18.3660917,15.8939004 16.5838528,15.641403 15.2925411,16.5370418 L15.1400224,16.6500392 L15.2877722,16.9328127 C15.7055576,17.7795289 15.9450803,18.7029358 15.9916219,19.6457123 L16.0000002,20.0000495 L15.9932725,20.116625 C15.9355074,20.6139638 15.5128363,21.0000038 15.0000002,21.0000038 C14.4871641,21.0000038 14.064493,20.6139638 14.0067279,20.116625 L14.0000002,20.0000038 L13.9953807,19.7831143 C13.8818181,17.1223139 11.6887513,15.0000032 9.00000021,15.0000036 C6.31124916,15.0000036 4.11818229,17.1223139 4.00461973,19.7831143 L4.00000021,20.0000036 L3.99327248,20.1166241 C3.9355074,20.613963 3.51283628,21.0000038 3.00000021,21.0000038 C2.48716414,21.0000038 2.06449302,20.613963 2.00672794,20.1166241 L2.00000021,20.0000029 L2.00715823,19.6926947 C2.08576577,17.9560234 2.80850188,16.3063355 4.04052021,15.0694627 Z M16.9999999,7 C18.6568499,7 19.9999999,8.34315 19.9999999,10 C19.9999999,11.5976768 18.751076,12.9036606 17.1762722,12.9949073 L16.9999999,13 L16.8237275,12.9949073 C15.3072498,12.9070401 14.0929598,11.6927504 14.0050926,10.1762724 L13.9999999,10 L14.0050926,9.82372764 C14.0963393,8.24892392 15.4023231,7 16.9999999,7 Z M8.99999983,3 C11.2091398,3 12.9999998,4.79086 12.9999998,7 C12.9999998,9.14219636 11.3160323,10.8910789 9.19964025,10.9951047 L8.99999983,11 L8.8003594,10.9951047 C6.75223807,10.8944346 5.10909287,9.25331534 5.00521474,7.20603943 L4.99999983,7 L5.00489513,6.80035957 C5.10892089,4.68396753 6.85780346,3 8.99999983,3 Z M17,9 L16.8833788,9.00672773 C16.4242968,9.06004936 16.0600493,9.42429693 16.0067277,9.88337886 L16,10 L16.0067277,10.1166212 C16.0644928,10.61396 16.4871639,11 17,11 C17.552285,11 18,10.552285 18,10 C18,9.48716393 17.61396,9.06449281 17.1166211,9.00672773 L17,9 Z M8.99999991,5 L8.85073751,5.00548574 C7.86762026,5.0780174 7.0821351,5.86122634 7.00604438,6.84334951 L6.99999991,7 L7.00548565,7.14926241 C7.08183475,8.18412267 7.94563764,9 8.99999991,9 C10.1045699,9 10.9999999,8.10457 10.9999999,7 C10.9999999,5.94563773 10.1841226,5.08183483 9.14926232,5.00548573 L8.99999991,5 Z"
                id="Icon"
                fill="currentColor"
                fillRule="nonzero"
              ></path>
            </g>
          </svg>
          Clients
        </Link>
        {this.state.selectedMainMenu === "Clients" && (
          <>
            <Link
              id="all-clients"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100   hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-clients"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900  xl:bg-purple-100 "
                  : ""
              }`}
              to="/clients"
            >
              All Clients
            </Link>
          </>
        )}

        <Link
          id="suppliers"
          className={`menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none `}
          to="/suppliers"
        >
          <i className="fas fa-industry mr-2"></i> Suppliers
        </Link>
        {this.state.selectedMainMenu === "Suppliers" && (
          <>
            <Link
              id="all-suppliers"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-suppliers"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/suppliers"
            >
              All Suppliers
            </Link>
          </>
        )}

        <Link
          id="skus"
          className={`menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none `}
          to="/products/base"
        >
          <i className="fas fa-th mr-2"></i> Products
        </Link>

        {this.state.selectedMainMenu === "SKUs" && (
          <>
            <Link
              id="all-base-skus"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100   focus:outline-none ${
                this.state.selectedSubMenu === "all-base-skus"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/products/base"
            >
              All Base Products
            </Link>

            <Link
              id="all-skus"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100   focus:outline-none ${
                this.state.selectedSubMenu === "all-skus"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/products"
            >
              All Products
            </Link>

            <Link
              id="suppliers-product"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "suppliers-product"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/products/supplier-product"
            >
              Supplier Product
            </Link>
          </>
        )}

        <Link
          id="locations"
          className={`menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none `}
          to="/locations"
        >
          <i className="fas fa-map-marker-alt mr-2"></i> Locations
        </Link>

        {this.state.selectedMainMenu === "Locations" && (
          <>
            <Link
              id="all-addresses"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-addresses"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/addresses"
            >
              All Addresses
            </Link>
            <Link
              id="all-locations"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-locations"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/locations"
            >
              All Locations
            </Link>
          </>
        )}

        <Link
          id="shipments"
          className={`menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none `}
          to="/shipments"
        >
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 24 24"
            className="text-white xl:text-gray-900 inline mr-2 mb-1"
          >
            <g
              id="Decoration-/-Icon-/-Shopping-/-Shipping"
              stroke="none"
              strokeWidth="1"
              fill="currentColor"
              fillRule="evenodd"
            >
              <path
                d="M21.6,11.22 L17,7.52 L17,4.99999851 L17.0000001,4.99999851 C17.050988,3.94842851 16.2414281,3.05388851 15.1900001,2.99999851 L3.79000007,2.99999851 L3.79000009,2.99999851 C2.74653009,3.06442501 1.94875009,3.95579551 2.00000009,4.99999851 L2.00000009,14.9999985 L2.00000003,14.9999985 C1.98101743,15.8122341 2.45527803,16.5552411 3.20000003,16.8800011 L3.1999999,16.8800014 C2.5730939,18.4136714 3.3081749,20.1651714 4.8418499,20.7920814 C6.3755199,21.4189874 8.1270199,20.6839064 8.7539299,19.1502314 C9.0345089,18.4638164 9.0509239,17.6978114 8.800006,16.9999985 L15.160006,16.9999985 L15.1600061,16.9999985 C14.5947291,18.5574411 15.3990391,20.2782511 16.9564861,20.8435211 C18.5139261,21.4087981 20.2347361,20.6044881 20.8000061,19.0470411 C21.0400061,18.3857961 21.0400061,17.6612411 20.8000064,16.9999985 L21.0000064,16.9999985 L21.0000063,16.9999985 C21.5522913,16.9999985 22.0000063,16.5522761 22.0000063,15.9999985 L22.0000063,11.9999985 L22.0000063,11.9999985 C21.9938043,11.6922913 21.8462633,11.4045863 21.6000063,11.2199913 L21.6,11.22 Z M20,12.48 L20,15 L17,15 L17,10.08 L20,12.48 Z M7,18 L7,18 C7,18.552285 6.552285,19 6,19 C5.447715,19 5,18.552285 5,18 C5,17.447715 5.447715,17 6,17 L6,17 C6.55228496,17 7,17.447715 7,18 L7,18 Z M12,15 L4,15 L4,5 L15,5 L15,15 L12,15 Z M19,18 L19,18 C19,18.552285 18.552285,19 18,19 C17.447715,19 17,18.552285 17,18 C17,17.447715 17.447715,17 18,17 L18,17 C18.552285,17 19,17.447715 19,18 L19,18 Z"
                id="Icon"
                fill="currentColor"
                fillRule="nonzero"
              ></path>
            </g>
          </svg>
          Shipments
        </Link>

        {this.state.selectedMainMenu === "Shipments" && (
          <>
            <Link
              id="all-shipments"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-shipments"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/shipments"
            >
              All Shipments
            </Link>
          </>
        )}

        <Link
          id="stocks"
          className={`menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none `}
          to="/product-stocks"
        >
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 24 24"
            className="text-white xl:text-gray-900 inline mr-2 mb-1"
          >
            <g
              id="Decoration-/-Icon-/-Shopping-/-Gift"
              stroke="none"
              strokeWidth="1"
              fill="currentColor"
              fillRule="evenodd"
            >
              <path
                d="M19.2,7 L18.81,7 L18.8100001,6.99999975 C18.9298331,6.67992275 18.9940911,6.34172275 19.0000001,5.99999975 L19.0000001,6.00000036 C18.9563364,4.30670036 17.5535301,2.96644036 15.8600001,3.00000036 L15.8599999,3.00000036 C14.2316299,3.03516696 12.7519099,3.95519536 11.9999999,5.40000036 L11.9999998,5.40000029 C11.2480858,3.95519029 9.76836984,3.03517029 8.13999984,3.00000029 L8.13999985,3.00000029 C6.44646985,2.96644009 5.04365985,4.30670029 4.99999985,6.00000029 L4.99999977,5.99999582 C5.00590794,6.34171882 5.07016547,6.67991882 5.18999877,6.99999582 L4.80000077,6.99999582 L4.80000084,6.99999581 C3.70038084,7.10440781 2.89360084,8.08046581 2.99801084,9.18009581 C2.99864118,9.18673428 2.99930471,9.19336951 3.00000141,9.20000141 L3.00000141,12.8000014 L3.00000135,12.8000021 C2.90360435,13.7992221 3.53462535,14.7247221 4.50000135,15.0000021 L4.50000135,19.3700021 L4.50000128,19.3700011 C4.56417748,20.3129601 5.36549228,21.0345911 6.31000128,21.0000011 L17.6900013,21.0000011 L17.6900012,21.0000011 C18.6492132,21.0338851 19.4567212,20.2888351 19.5000012,19.3300011 L19.5000012,15.0000011 L19.5000012,15.0000011 C20.4653772,14.7247181 21.0964012,13.7992211 21.0000012,12.8000011 L21.0000012,9.20000113 L21.0000013,9.20000003 C21.1154033,8.10148003 20.3184253,7.11739003 19.2199013,7.00199003 C19.2132713,7.00129353 19.2066378,7.00063019 19.2000012,7.00000002 L19.2,7 Z M19,9.2 L19,12.8 L19,12.8 C19.0120012,12.8661266 19.0120012,12.933873 19,13 L13,13 L13,9 L19,9 L19,9 C19.0120012,9.06612661 19.0120012,9.13387301 19,9.20000001 L19,9.2 Z M15.86,5 L15.8599999,5 C16.4494729,4.9656471 16.9572599,5.411075 17,6 L17,5.99999928 C16.9572618,6.58892428 16.449474,7.03434928 15.86,6.99999928 L13.4,6.99999928 L13.4,6.99999938 C13.757346,5.90894938 14.71898,5.12712938 15.86,4.99999938 L15.86,5 Z M6.99999983,6 L6.99999983,6.00000076 C7.04273815,5.41107576 7.55052595,4.96565076 8.13999995,5.00000076 L8.13999988,5.00000075 C9.27723988,5.13082175 10.2341499,5.91197175 10.5899999,7.00000075 L8.13999988,7.00000075 L8.13999983,7.00000075 C7.55052683,7.03435355 7.04273983,6.58892575 6.99999983,6.00000075 L6.99999983,6 Z M5,9.2 L5,9.2 C4.9879988,9.1338734 4.9879988,9.066127 5,9 L11,9 L11,13 L5,13 L5,13 C4.9879988,12.9338734 4.9879988,12.866127 5,12.8 L5,9.2 Z M6.5,15 L11,15 L11,19 L6.5,19 L6.5,15 Z M13,19 L13,15 L17.5,15 L17.5,19 L13,19 Z"
                id="Icon"
                fill="currentColor"
                fillRule="nonzero"
              ></path>
            </g>
          </svg>
          Stock
        </Link>

        {this.state.selectedMainMenu === "Stocks" && (
          <>
            <Link
              id="all-product-stocks"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-product-stocks"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/product-stocks"
            >
              All Product Stocks
            </Link>
          </>
        )}

        <Link
          id="client-orders"
          className={`menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none `}
          to="/client-orders"
        >
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 24 24"
            className="text-white xl:text-gray-900 inline mr-2 mb-1"
          >
            <g
              id="Decoration-/-Icon-/-Shopping-/-Cart-/-Full"
              stroke="none"
              strokeWidth="1"
              fill="currentColor"
              fillRule="evenodd"
            >
              <path
                d="M7.5,18 C8.32842712,18 9,18.6715729 9,19.5 C9,20.3284271 8.32842712,21 7.5,21 C6.67157288,21 6,20.3284271 6,19.5 C6,18.6715729 6.67157288,18 7.5,18 Z M17.5,18 C18.3284271,18 19,18.6715729 19,19.5 C19,20.3284271 18.3284271,21 17.5,21 C16.6715729,21 16,20.3284271 16,19.5 C16,18.6715729 16.6715729,18 17.5,18 Z M5.00000003,3.00000009 C5.42612996,2.98540309 5.8099082,3.24190491 5.96385399,3.63076882 L6.00000003,3.74000009 L6.58000005,6.00000009 L19.38,6.00000009 C20.0289739,6.01045024 20.6288753,6.33477183 20.9937778,6.86359668 L21.08,7.00000009 C21.393601,7.52279104 21.4500399,8.15683154 21.2407631,8.72252283 L21.17,8.89000014 L17.89,15.4500002 C17.7393778,15.7489157 17.4508459,15.950092 17.1241185,15.9919091 L17,16.0000002 L8.00000003,16.0000002 C7.57387013,16.0145963 7.1900919,15.7580952 7.03614607,15.3692314 L7.00000003,15.2600002 L4.24000003,5.00000009 L3.00000003,5.00000009 C2.44771503,5.00000009 2.00000003,4.55228509 2.00000003,4.00000009 C2.00000003,3.48716401 2.38604,3.06449291 2.88337886,3.00672782 L3.00000003,3.00000009 L5.00000003,3.00000009 Z M19.38,8 L7.13,8 L8.76,14 L16.38,14 L19.38,8 Z"
                id="Icon"
                fill="currentColor"
                fillRule="nonzero"
              ></path>
              <circle
                id="Item"
                fill="currentColor"
                fillRule="nonzero"
                cx="13"
                cy="11"
                r="2"
              ></circle>
            </g>
          </svg>
          Sales
        </Link>

        {this.state.selectedMainMenu === "Sales" && (
          <>
            <Link
              id="all-client-orders"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-client-orders"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/client-orders"
            >
              Client Orders
            </Link>
            <Link
              id="all-product-pricings"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-product-pricings"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/product-pricings"
            >
              Product Pricings
            </Link>
          </>
        )}

        <Link
          id="supplier-quotes"
          className={`menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none `}
          to="/supplier-quotes"
        >
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 24 24"
            className="text-white xl:text-gray-900 inline mr-2 mb-1"
          >
            <g data-name="Layer 2">
              <g data-name="credit-card">
                <rect width="24" height="24" opacity="0" />
                <path
                  fill="currentColor"
                  d="M19 5H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3zM4 8a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1H4zm16 8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5h16z"
                />
                <path fill="currentColor" d="M7 15h4a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2z" />
                <path fill="currentColor" d="M15 15h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2z" />
              </g>
            </g>
          </svg>
          Purchases
        </Link>

        {this.state.selectedMainMenu === "Purchases" && (
          <>
            <Link
              id="all-supplier-orders"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-supplier-orders"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/supplier-orders"
            >
              Supplier Orders
            </Link>
            <Link
              id="all-supplier-quotes"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-supplier-quotes"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/supplier-quotes"
            >
              Supplier Quotes
            </Link>
          </>
        )}

        <Link
          id="invoices"
          className={`menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none `}
          to="/invoices"
        >
          <svg
            width="16px"
            height="16px"
            viewBox="0 0 24 24"
            className="text-white xl:text-gray-900 inline mr-2 mb-1"
          >
            <g data-name="Layer 2">
              <g data-name="file-text">
                <rect width="24" height="24" opacity="0" fill="currentColor" />
                <path fill="currentColor" d="M15 16H9a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z" />
                <path fill="currentColor" d="M9 14h3a1 1 0 0 0 0-2H9a1 1 0 0 0 0 2z" />
                <path
                  fill="currentColor"
                  d="M19.74 8.33l-5.44-6a1 1 0 0 0-.74-.33h-7A2.53 2.53 0 0 0 4 4.5v15A2.53 2.53 0 0 0 6.56 22h10.88A2.53 2.53 0 0 0 20 19.5V9a1 1 0 0 0-.26-.67zM14 5l2.74 3h-2a.79.79 0 0 1-.74-.85zm3.44 15H6.56a.53.53 0 0 1-.56-.5v-15a.53.53 0 0 1 .56-.5H12v3.15A2.79 2.79 0 0 0 14.71 10H18v9.5a.53.53 0 0 1-.56.5z"
                />
              </g>
            </g>
          </svg>
          Invoices
        </Link>

        {this.state.selectedMainMenu === "Invoices" && (
          <>
            <Link
              id="all-invoices"
              className={`ml-4 sub-menu-item-fixed  hover:bg-gray-900 xl:hover:bg-purple-100  focus:outline-none ${
                this.state.selectedSubMenu === "all-invoices"
                  ? "border-l-4 border-purple-200 font-semibold bg-purple-900 hover:bg-purple-900 xl:bg-purple-100 xl:hover:bg-purple-100"
                  : ""
              }`}
              to="/invoices"
            >
              Invoices
            </Link>
          </>
        )}
      </Menu>
    );
  }
}

export default SideMenu;
